import React from "react";
import { Button, Grid2, Typography, ButtonGroup} from "@mui/material";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";


export const HomeButton=({textContents}) => {
    return (
      <Grid2 item xs={12} align="centre" sx={{ textAlign: "centre"}}>
          <Button color="secondary" variant="contained" to="/" component={Link}>
            { textContents }
          </Button>
      </Grid2>
    );
  }

HomeButton.propTypes = {
    textContents: PropTypes.string,
}

export const ParentContainer=({ children })=>{
    return (
    <Grid2 container spacing={0} align="center">
        { children }
    </Grid2>
    );
}

ParentContainer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element)
      ])
}


export const PageHeader=({HeaderContents}) => {
  return (
      <Grid2 item xs={12} align="centre">
          <Typography variant="h4" component="h4">
              { HeaderContents }
          </Typography>

      </Grid2>
  );
}

PageHeader.propTypes = {
    HeaderContents: PropTypes.string,
};

export const HomePageButtonList=()=>{

  return(
      <ButtonGroup>
          disableElevation
          variant=contained
          color=primary
          <Button color="primary" to='/join' component={Link}>
              Join a Room
          </Button>
          <Button color="secondary" to='/create' component={Link}>
              Create a Room
          </Button>
      </ButtonGroup>
  )
}